import axios, { AxiosResponse } from "axios";
import {
	getRequest,
	postRequest
} from "@/Utils/Service/BackendService";
import {
	Tag,
	TagBulkUpsertRequest,
	TagEntityType
} from "@/Contracts/Tags";

const tagsUrl = "/v2/tags/";
const tagsBulkUpsertUrl = "/v2/tags/bulk-upsert/";

export const listTagsByEntityType = async (
	entityType: TagEntityType
): Promise<Tag[]> => {
	try {
		const url = `${tagsUrl}?filter=entity_type=${entityType}`;
		const response: AxiosResponse<Tag[]> = await axios(
			getRequest(url, null, false, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const bulkUpsertTags = async (
	request: TagBulkUpsertRequest
): Promise<Tag[]> => {
	try {
		const response: AxiosResponse<Tag[]> = await axios(
			postRequest(tagsBulkUpsertUrl, request, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};